export const BUTTON_VARIABLES = [
  { label: '100', stake: 100 },
  { label: '500', stake: 500 },
  { label: '1k', stake: 1000 },
  { label: '5k', stake: 5000 },
  { label: '10k', stake: 10000 },
  { label: '50k', stake: 50000 },
  { label: '100k', stake: 100000 },
  { label: '500k', stake: 500000 },
];
